// Modal history helper — modal aç/kapatma işlemlerini browser history ile
// senkronize eder. Tüm modal state'i URL query parametrelerinden türer:
//   ?modal=quick-entry
//   ?modal=import
//   ?modal=property-new
//   ?modal=property-edit&pid=<id>
//   ?modal=property-view&pid=<id>
//   ?modal=ai-single
// Böylece:
//   * Browser Back açık modal'ı kapatır (URL geriye gider)
//   * Browser Forward aynı modal'ı tekrar açar (URL ileri gider)
//   * Doğrudan URL / sayfa refresh doğru modal'ı açar
//   * Uygulama içi Kapat butonu `history.back()` çağırır → aynı akış

const MODAL_KEY = "modal";
const PARAM_KEY = "pid"; // property id when applicable

export function readModalFromUrl() {
  try {
    const p = new URLSearchParams(window.location.search);
    return { id: p.get(MODAL_KEY), pid: p.get(PARAM_KEY) };
  } catch { return { id: null, pid: null }; }
}

/** Push a new history entry that OPENS the specified modal. */
export function pushOpenModal(modalId, extras = {}) {
  const url = new URL(window.location.href);
  url.searchParams.set(MODAL_KEY, modalId);
  if (extras.pid != null) url.searchParams.set(PARAM_KEY, String(extras.pid));
  else url.searchParams.delete(PARAM_KEY);
  window.history.pushState(
    { modal: modalId, ...extras, at: Date.now() },
    "",
    url.toString()
  );
}

/** Replace the current history entry (used for form-tab switches so we don't
 *  create a stack of dozens of history entries). */
export function replaceModalParam(key, value) {
  const url = new URL(window.location.href);
  if (value == null || value === "") url.searchParams.delete(key);
  else url.searchParams.set(key, String(value));
  window.history.replaceState(
    { ...(window.history.state || {}), [key]: value },
    "",
    url.toString()
  );
}

/** Close the top-most modal by moving history back one step. If nothing to
 *  go back to, clear the URL and rely on the popstate listener. */
export function popCloseModal() {
  // Guard: if user landed on this page WITH the modal already open (deep
  // link / refresh) history.length is unreliable. We push a clean state
  // first so `back()` reliably brings us to Dashboard-without-modal.
  const cur = readModalFromUrl();
  if (cur.id) {
    // Try back(); if we happen to be at the entry point of the history
    // stack this becomes a no-op — fall back to a clean replaceState.
    const before = window.history.length;
    window.history.back();
    // Fallback safety: if history didn't move (e.g. first entry), clear the
    // URL query manually so the modal doesn't stay stuck open.
    setTimeout(() => {
      if (readModalFromUrl().id === cur.id && window.history.length === before) {
        const url = new URL(window.location.href);
        url.searchParams.delete(MODAL_KEY);
        url.searchParams.delete(PARAM_KEY);
        window.history.replaceState({}, "", url.toString());
        window.dispatchEvent(new PopStateEvent("popstate"));
      }
    }, 50);
  }
}
